/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2019 Deere & Company

import './alert-bar-base.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';

const defaultTimeoutLength = 10000;
const noOp = () => {};

export class AlertBarBase extends Component {

    state = {
        timer: null,
    };

    componentDidMount() {

        this.setTimer();

    }

    shouldComponentUpdate(nextProps) {

        return !isEqual(this.props, nextProps);

    }

    componentDidUpdate() {

        this.clearTimer();
        this.setTimer();

    }

    setTimer = () => {

        if (this.props.willAutoDismiss) {

            this.setState({
                timer: global.setTimeout(this.props.dismissHandler, this.props.timeoutLength),
            });

        }

    };

    clearTimer = () => {

        if (this.state.timer) {

            global.clearTimeout(this.state.timer);

        }

    };

    render() {

        const iconClasses = `icon ${this.props.iconClass}`;

        return (
            <div className="alert-bar-base">
                <span className={iconClasses} />
                <div className="alert-bar-base-content">
                    <div className="alert-bar-base-header">
                        <span className="alert-bar-base-title">{this.props.alertTitle}</span>
                        {this.props.canDismiss && (
                            <span className="icon-wrapper" onClick={this.props.dismissHandler}>
                                <i className="cancel-icon fa fa-times-circle" />
                            </span>
                        )}
                    </div>
                    {this.props.children && <div className="alert-bar-base-body">{this.props.children}</div>}
                </div>
            </div>
        );

    }

}

AlertBarBase.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    children: PropTypes.any,
    dismissHandler: PropTypes.func,
    iconClass: PropTypes.string.isRequired,
    canDismiss: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool,
};

AlertBarBase.defaultProps = {
    dismissHandler: noOp,
    canDismiss: true,
    timeoutLength: defaultTimeoutLength,
};
